

export const NEWSLETTER_TYPE_FIXED = 'fixed';

export const NEWSLETTER_WORDING = {
  [NEWSLETTER_TYPE_FIXED]: 'Newsletter Fixe',
} as const;

export const NEWSLETTER_TYPE_LABELS = {
  sell: 'Vente',
  dpe: 'DPE',
  legal: 'Vivre ensemble',
  works: 'Travaux',
  rental: 'Location',
} as const;

export const NEWSLETTER_THEME_TO_TYPE: Record<string, NewsletterType> = {
  DPE: 'dpe',
  Vente: 'sell',
  Travaux: 'works',
  'Vivre ensemble': 'legal',
  Location: 'rental',
};

export type NewsletterType = keyof typeof NEWSLETTER_TYPE_LABELS;

// Interface for fixed newsletter with templates
export interface FixedNewsletter {
  id: string;
  date: string;
  slug: string;
  title: string;
  availableDate: string;
  type: NewsletterType;
  sentAt?: string;
  templates: {
    name: string;
    pageCount: number;
  }[];
}

// Type for newsletter template data
export interface NewsletterTemplate {
  name: string;
  pageCount: number;
  title: string;
  content: string;
} 
